var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_27877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.14 20.33C30.7801 18.9724 28.9734 18.1548 27.056 18.0292C25.1385 17.9035 23.2406 18.4784 21.7152 19.647C20.1897 20.8155 19.1404 22.4982 18.7624 24.3822C18.3844 26.2663 18.7034 28.2235 19.66 29.89L18.5 34L22.7 32.9C23.8597 33.5453 25.1629 33.8891 26.49 33.9C27.5411 33.9093 28.5836 33.7098 29.557 33.313C30.5304 32.9163 31.4153 32.3302 32.1604 31.5888C32.9055 30.8474 33.496 29.9654 33.8977 28.994C34.2993 28.0226 34.504 26.9812 34.5 25.93C34.506 24.8891 34.3039 23.8575 33.9054 22.8958C33.507 21.9341 32.9204 21.0617 32.18 20.33H32.14ZM26.5 32.52C25.3203 32.5245 24.1619 32.2064 23.15 31.6L22.9 31.46L20.41 32.12L21.08 29.68L20.92 29.44C20.1392 28.2016 19.7923 26.7387 19.9339 25.2816C20.0755 23.8244 20.6976 22.4557 21.7023 21.3908C22.707 20.326 24.0372 19.6253 25.4836 19.3992C26.9301 19.1731 28.4107 19.4344 29.6924 20.1418C30.9741 20.8493 31.9842 21.9629 32.5638 23.3073C33.1434 24.6517 33.2595 26.1506 32.8939 27.5683C32.5282 28.9859 31.7017 30.2417 30.5442 31.1381C29.3867 32.0346 27.964 32.5207 26.5 32.52ZM30.12 27.59C29.92 27.49 28.95 27.01 28.77 26.94C28.59 26.87 28.45 26.84 28.32 27.04C28.1243 27.3112 27.914 27.5716 27.69 27.82C27.58 27.95 27.46 27.97 27.26 27.82C26.6769 27.5798 26.1391 27.2416 25.67 26.82C25.2513 26.4379 24.8909 25.9966 24.6 25.51C24.48 25.32 24.6 25.21 24.68 25.11C24.76 25.01 24.88 24.88 24.98 24.76C25.0618 24.6599 25.1291 24.5489 25.18 24.43C25.2073 24.3757 25.2215 24.3158 25.2215 24.255C25.2215 24.1943 25.2073 24.1343 25.18 24.08C25.11 24 24.72 23 24.55 22.61C24.38 22.22 24.23 22.28 24.11 22.27H23.73C23.63 22.2722 23.5315 22.2945 23.4404 22.3358C23.3493 22.377 23.2675 22.4363 23.2 22.51C22.9748 22.7232 22.7963 22.9808 22.6758 23.2666C22.5553 23.5523 22.4954 23.86 22.5 24.17C22.5673 24.917 22.8485 25.6288 23.31 26.22C24.1622 27.4958 25.3301 28.5293 26.7 29.22C27.17 29.42 27.54 29.54 27.83 29.64C28.2356 29.7599 28.6635 29.7838 29.08 29.71C29.3552 29.6554 29.6159 29.5435 29.845 29.3815C30.0742 29.2196 30.2667 29.0112 30.41 28.77C30.5428 28.4757 30.5846 28.1483 30.53 27.83C30.53 27.75 30.35 27.7 30.15 27.6",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_27877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.e5d91292aae9750ecd4ebf20a2a4b522.svg";
export { ForwardRef as ReactComponent };